'use client';
import 'src/http-setup';

/**
 * **CRITICAL COMPONENT - HANDLE WITH CARE**
 *
 * This component is essential for the proper initialization of HTTP clients on the client side.
 * It MUST be rendered as the first component in the application layout to ensure proper setup.
 * It MUST be client-side only.
 *
 * @returns {null} This component doesn't render anything, it only executes setup code
 */
export function SetupHttpClients(): null {
  return null;
}
